import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState, useEffect, useRef } from "react"; // Añadido useRef
import "../styles/NavBar.css";
import Swal from "sweetalert2";

export default function Navbar() {
  const { token, logout, rol, jugadorId } = useAuth(); // Añadido jugadorId
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Estado para el menú desplegable
  const [nombreJugador, setNombreJugador] = useState(""); // Estado para el nombre del jugador
  const dropdownRef = useRef(null); // Referencia para el menú desplegable
  const navigate = useNavigate();

  // Efecto de scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Simulación de obtener el nombre del jugador (puedes reemplazar con datos reales)
  useEffect(() => {
    if (token) {
      // Aquí podrías hacer una petición al backend para obtener el nombre del jugador
      setNombreJugador("Mi Datos"); // Reemplaza con datos reales
    }
  }, [token]);

  // Manejar clic fuera del menú desplegable
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "¿Estás seguro de que deseas cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cerrar sesión",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        navigate("/"); // Redirige al Home
      }
    });
  };

  return (
    <nav className={isScrolled ? "navbar scrolled" : "navbar"}>
      <div className="navbar-container">
        <Link to="/" className="logo" onClick={closeMobileMenu}>
          <span className="logo-icon">🎾</span>
          <span className="logo-text">Liga Sanguillermina</span>
        </Link>

        {/* Hamburger Menu */}
        <div
          className={isMobileMenuOpen ? "hamburger active" : "hamburger"}
          onClick={toggleMobileMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Menu */}
        <div className={isMobileMenuOpen ? "menu active" : "menu"}>
          <Link to="/" className="menu-link" onClick={closeMobileMenu}>
            Inicio
          </Link>
          {!token ? (
            <>
              <Link to="/login" className="menu-link" onClick={closeMobileMenu}>
                Login
              </Link>
              <Link
                to="/registro"
                className="menu-link btn-registrarse"
                onClick={closeMobileMenu}
              >
                Registrarse
              </Link>
            </>
          ) : (
            <>
              <Link to="/ranking" className="menu-link" onClick={closeMobileMenu}>
                Ranking
              </Link>
              <Link to="/torneos" className="menu-link" onClick={closeMobileMenu}>
                Torneos
              </Link>
              {rol === "admin" && (
                <Link
                  to="/admin/panel"
                  className="menu-link"
                  onClick={closeMobileMenu}
                >
                  Panel Administrador
                </Link>
              )}
              <div className="menu-dropdown" ref={dropdownRef}>
                <button
                  className="menu-link dropdown-toggle"
                  onClick={toggleDropdown}
                >
                  {nombreJugador} ▼
                </button>
                {isDropdownOpen && (
                  <div className="dropdown-menu">
                    <Link
                      to="/perfil"
                      className="dropdown-item"
                      onClick={closeMobileMenu}
                    >
                      Mi Perfil
                    </Link>
                    <Link
                      to={`/perfiltorneosjugados/${jugadorId}`}
                      className="dropdown-item"
                      onClick={closeMobileMenu}
                    >
                      Mis Torneos
                    </Link>
                    <button className="dropdown-item" onClick={handleLogout}>
                      Cerrar Sesión
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}